import axios from 'axios';
import * as keys from '../../config/apiKeys';

// Returns a promise that will ether resolve or reject.
export default function apiPost(apiUrl, data, options, skipAuthAndUserToken, contentType, skipKey) {

  if (!data) {
    return new Promise((resolve, reject) => {
      reject("null or undefined data in API post.");
    })
  }

  options = options || {};
  options.headers = options.headers || {};
  if (!skipKey) {
    options.headers['api_key'] = options.headers['api_key'] || keys.MYAPI_KEY;
  }
  options.headers['Content-Type'] = 'application/json';

  if (!skipAuthAndUserToken) {
    options.headers['Authorization'] = 'Bearer ' + localStorage.getItem('token');
  }

  if (contentType) {
    options.headers['Content-Type'] = contentType;
  }

  return new Promise((resolve, reject) => {
    var url = window.location.protocol + "//" + window.location.host + apiUrl;
    axios.post(url, data, options)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
